import { render, staticRenderFns } from "./BottomButtons.vue?vue&type=template&id=7f3aac3c&scoped=true&"
import script from "./BottomButtons.vue?vue&type=script&lang=js&"
export * from "./BottomButtons.vue?vue&type=script&lang=js&"
import style0 from "./BottomButtons.vue?vue&type=style&index=0&id=7f3aac3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3aac3c",
  null
  
)

export default component.exports